/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
  GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  GetApiV1ExamRevisionLangBotexamlangidTranslation401,
  GetApiV1ExamRevisionLangBotexamlangidTranslation404,
  GetApiV1ExamRevisionLangBotexamlangidTranslation500,
} from "../../types/examRevisionController/GetApiV1ExamRevisionLangBotexamlangidTranslation.ts";

function getGetApiV1ExamRevisionLangBotexamlangidTranslationUrl(
  botExamLangId: GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams["botExamLangId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/revision/lang/${botExamLangId}/translation` as const,
  };
  return res;
}

/**
 * @description Retorna os dados do editor de tradução para um idioma alvo, paginados por questão. Exibe lado a lado o texto original em pt-BR e o texto traduzido. Cada página contém uma questão com suas opções. Retorna 404 se o idioma ou a versão pt-BR não forem encontrados. **(Requer Authorization para autenticação)**
 * @summary Carregar editor de tradução de idioma da prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/translation}
 */
export async function getApiV1ExamRevisionLangBotexamlangidTranslation(
  botExamLangId: GetApiV1ExamRevisionLangBotexamlangidTranslationPathParams["botExamLangId"],
  params?: GetApiV1ExamRevisionLangBotexamlangidTranslationQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamRevisionLangBotexamlangidTranslationQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamRevisionLangBotexamlangidTranslation401
      | GetApiV1ExamRevisionLangBotexamlangidTranslation404
      | GetApiV1ExamRevisionLangBotexamlangidTranslation500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamRevisionLangBotexamlangidTranslationUrl(
      botExamLangId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
